import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { THEME_CONFIG } from '../lumilogin.token';

@Injectable({
    providedIn: 'root'
})
export class ThemeConfigService {
    
    
    public _configSubject: BehaviorSubject<any>;

    constructor(@Inject(THEME_CONFIG) public config : any) {
        this._configSubject = new BehaviorSubject(this.config);
    }

    setModel(model: any) {
        this.config = Object.assign({}, this.config, model);
        this._configSubject.next(this.config);
    }

}
